var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStraightOval = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.11 52H34.77c-.3 0-5.77-1-5.77-12.1S34.52 28 34.76 28h26.46c.31.05 5.78 1.07 5.78 12s-5.5 12-5.74 12h-.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.17 53H34.64c-.27-.06-6.64-1.08-6.64-13.1s6.37-12.85 6.64-12.9h26.72c.27.06 6.64 1.1 6.64 13s-6.3 13-6.57 13h-.26ZM34.9 51h26.24c.15 0 4.86-1 4.86-11s-4.3-10.87-4.87-11H34.82c-.14 0-4.82.76-4.82 10.9 0 9.67 4.36 10.97 4.9 11.1Z"
  })));
};
export default SvgStraightOval;